import { render } from "./CookiePopup.vue?vue&type=template&id=c5f55704"
import script from "./CookiePopup.vue?vue&type=script&lang=js"
export * from "./CookiePopup.vue?vue&type=script&lang=js"

import "./CookiePopup.vue?vue&type=style&index=0&id=c5f55704&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__